import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Checkbox from '@material-ui/core/Checkbox';

const GreenCheck = withStyles({
    root: {
      padding: '0.4em 0.4em',
      color: green[400],
      '&$checked': {
        color: green[600],
      },
    },
  })(props => <Checkbox color="default" {...props} />);

export default function GreenCheckbox(props) {
  return (
    <GreenCheck 
      key={props.key} 
      checked={true} 
      value="checkedG" 
      disableRipple
    />
  );
}